export const isSmallScreen = (windowWidth: number) => {
  return windowWidth <= 1440;
};
